import { MAIL_MAX_PARTICIPANTS } from '../constants/mail.js';
import { z } from 'zod';
import { idSchema } from './common.js';
import { mailAddressSchema } from './mail-account.js';
export const mailBusinessSendOptionsSchema = z.object({
    bcc: z.array(mailAddressSchema).max(MAIL_MAX_PARTICIPANTS).optional(),
    mailAccountId: idSchema.optional(),
    mailAddressId: idSchema.optional(),
    mailAttemptKey: z.string().min(8).max(200).optional(),
});
export const mailBusinessDeliverySchema = z.object({
    businessRecordPending: z.boolean().optional(),
    attemptId: idSchema,
    state: z.enum(['PREPARED', 'SENDING', 'ACCEPTED', 'PARTIAL', 'REJECTED', 'UNCERTAIN']),
    archiveStatus: z.enum(['PENDING', 'ARCHIVED']),
    messageId: idSchema.nullable(),
    sourceId: idSchema.nullable(),
});
export const mailBusinessSendResultSchema = z.object({
    sentAt: z.string().datetime(),
    delivery: mailBusinessDeliverySchema.optional(),
});
//# sourceMappingURL=mail-outbound.js.map